import { UseFormReturn } from "react-hook-form";
import NumberEditor from "../Global/Editors/NumberEditor";
import TextEditor from "../Global/Editors/TextEditor";
import { useGlobalData } from "../GlobalDataProvider";
import SelectEditor from "../Global/Editors/SelectEditor";
import { DTOBuilding, DTOModule } from "../../types/building";
import { IModuleByggnadsdata } from "../../types/ModuleDatas";
import { nameof } from "../Global/Utils";
import { MapTooltip } from "../../types/globalData";
import { logDebugSilently } from "../../modules/logger";

interface IProps {
  module: DTOModule;
  data: any;
  formHook: UseFormReturn;
  building: DTOBuilding;
}

const ConfigByggnadsData = ({ module, data, formHook, building }: IProps) => {
  const globalData = useGlobalData();

  // const zones = globalData.data ? globalData.data.Data1.TemperatureIntervals.map((r) => r.Namn) : [];
  const kommuner = globalData.data ? globalData.data.Gemensamt.Kommuner.map((r) => r.Kommun) : [];
  kommuner.splice(0, 0, "");
  const verksamheter = globalData.data ? globalData.data.Byggnadsdata.Verksamhet.map((r) => r.Verksamhet) : [];
  verksamheter.splice(0, 0, "");
  const nybyggnadsÅr = globalData.data ? globalData.data.Byggnadsdata.Nybyggnadsår.map((r) => r.Nybyggnadsår) : [];
  nybyggnadsÅr.splice(0, 0, "");
  const energikällor = globalData.data ? globalData.data.Byggnadsdata.Värmekälla.map((r) => r.Värmekälla) : [];
  energikällor.splice(0, 0, "");

  const watch = formHook.watch;

  const energikalla = watch(nameof<IModuleByggnadsdata>("energikälla"));

  const titleTappvarmvatten = globalData.data?.Byggnadsdata.Värmekälla.find((r) => r.Värmekälla === energikalla)?.TappvarmvattenFråga;
  if (!titleTappvarmvatten) formHook.setValue(nameof<IModuleByggnadsdata>("producerarTappvarmvatten"), "");
  logDebugSilently("Render : ByggnadsDataEditor");

  return (
    <>
      <div className="row overflow-hidden gy-0">
        {/* <div className="col-12">
          <div className="mb-1 input-group has-validation">
            <label className="form-label w-100">
              Byggnad
              <input type="text" className={"form-control "} value={building.name} readOnly={true} disabled={true} />
            </label>
          </div>
        </div> */}

        <div className="col-sm-6">
          <div className="mb-1 input-group has-validation">
            <label className="form-label w-100">
              Område
              <input type="text" className={"form-control "} value={data[nameof<IModuleByggnadsdata>("område")]} readOnly={true} disabled={true} />
            </label>
          </div>
        </div>

        <div className="col-sm-6">
          <div className="mb-1 input-group has-validation">
            <label className="form-label w-100">
              Byggnadens area
              <input type="text" className={"form-control "} value={data[nameof<IModuleByggnadsdata>("byggnadArea")]} readOnly={true} disabled={true} />
            </label>
          </div>
        </div>

        {/* <div className="col-lg-12">
          <NumberEditor
            label="Byggnadens area"
            fieldName={nameof<IModuleByggnadsdata>("byggnadArea")}
            tooltipId="Byggnadsdata_ByggnadsArea"
            formHook={formHook}
            options={{
              validate: {
                required: (v) => {
                  return !v ? "Ange byggnadsarea" : undefined;
                },
              },
            }}
          />
        </div>

        <div className="col-12">
          <TextEditor label="Område" fieldName={nameof<IModuleByggnadsdata>("område")} formHook={formHook} />
        </div> */}

        <div className="col-sm-6">
          <TextEditor label="Företag" fieldName={nameof<IModuleByggnadsdata>("företag")} formHook={formHook} tooltipId={nameof<MapTooltip>("Byggnadsdata_företag")} />
        </div>

        <div className="col-sm-6">
          <SelectEditor
            label="Kommun"
            fieldName={nameof<IModuleByggnadsdata>("kommun")}
            tooltipId={nameof<MapTooltip>("Byggnadsdata_kommun")}
            formHook={formHook}
            items={kommuner}
            options={{
              validate: {
                required: (v) => {
                  return !v ? "Ange kommun" : undefined;
                },
              },
            }}
          />
        </div>

        <div className="col-sm-6">
          <TextEditor label="Byggnadens adress" fieldName={nameof<IModuleByggnadsdata>("adress")} formHook={formHook} tooltipId={nameof<MapTooltip>("Byggnadsdata_adress")} />
        </div>

        <div className="col-sm-3">
          <TextEditor label="Postnummer" fieldName={nameof<IModuleByggnadsdata>("postnummer")} formHook={formHook} tooltipId={nameof<MapTooltip>("Byggnadsdata_postnummer")} />
        </div>
        <div className="col-sm-3">
          <TextEditor label="Ort" fieldName={nameof<IModuleByggnadsdata>("ort")} formHook={formHook} tooltipId={nameof<MapTooltip>("Byggnadsdata_ort")} />
        </div>

        <div className="col-lg-6">
          <SelectEditor
            label="Verksamhet"
            fieldName={nameof<IModuleByggnadsdata>("verksamhet")}
            tooltipId={nameof<MapTooltip>("Byggnadsdata_verksamhet")}
            formHook={formHook}
            items={verksamheter}
            options={{
              validate: {
                required: (v) => {
                  return !v ? "Ange verksamhet" : undefined;
                },
              },
            }}
          />
        </div>
        <div className="col-lg-6">
          <SelectEditor
            label="Nybyggnadsår"
            fieldName={nameof<IModuleByggnadsdata>("nybyggnadsår")}
            tooltipId={nameof<MapTooltip>("Byggnadsdata_nybyggnadsår")}
            formHook={formHook}
            items={nybyggnadsÅr}
            options={{
              validate: {
                required: (v) => {
                  return !v ? "Ange nybyggnadsår" : undefined;
                },
              },
            }}
          />
        </div>

        <div className="col-lg-12">
          <SelectEditor
            label="Huvudsaklig energikälla för central uppvärmning"
            fieldName={nameof<IModuleByggnadsdata>("energikälla")}
            tooltipId={nameof<MapTooltip>("Byggnadsdata_energikälla")}
            formHook={formHook}
            items={energikällor}
            options={{
              validate: {
                required: (v) => {
                  return !v ? "Ange huvudsaklig energikälla" : undefined;
                },
              },
            }}
          />
        </div>

        {titleTappvarmvatten ? (
          <div className="col-lg-6">
            <SelectEditor
              label={titleTappvarmvatten}
              fieldName={nameof<IModuleByggnadsdata>("producerarTappvarmvatten")}
              tooltipId={nameof<MapTooltip>("Byggnadsdata_producerarTappvarmvatten")}
              formHook={formHook}
              items={["", "Ja", "Nej"]}
              options={{
                validate: {
                  required: (v) => {
                    return !v ? "Ange om tappvarmvatten produceras eller ej" : undefined;
                  },
                },
              }}
            />
          </div>
        ) : (
          <></>
        )}
      </div>
    </>
  );
};

export default ConfigByggnadsData;
